import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

import { IconLoading } from '../../../assets/icon';
import Button from '../../../components/Button/Button';
import ButtonTypes from '../../../constants/buttonTypes';
import getEbayTaskResultFile from '../../../thunks/ebay/getEbayTaskResultFile';

const buttonClassName = 'p-[5px]';

function RequestEbayFile({
  taskId, account, btnText, isResultFile
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const {
    enqueueSnackbar,
  } = useSnackbar();

  const requestResultFile = () => {
    setLoading(true);
    dispatch(getEbayTaskResultFile({
      taskId,
      account,
      type: isResultFile ? 'result_file' : 'input_file'
    }))
      .unwrap()
      .then(({ file }) => {
        window.open(file, '_blank');
      })
      .catch(() => {
        enqueueSnackbar('Error on file request', {
          variant: 'error',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    loading ? (
      <div className="flex justify-center">
        <IconLoading className="spin" />
      </div>
      ) : (
        <Button
          text={btnText}
          type={ButtonTypes.LIGHT}
          containerStyle={buttonClassName}
          onClick={requestResultFile}
          loading
        />
      )
  );
}

RequestEbayFile.propTypes = {
  taskId: PropTypes.string.isRequired,
  account: PropTypes.string.isRequired,
  btnText: PropTypes.string,
  isResultFile: PropTypes.bool,
};

RequestEbayFile.defaultProps = {
    btnText: 'Result File',
  isResultFile: true
};

export default RequestEbayFile;
